import { setupUWA } from "@onestore/uwa"
import type { Middleware } from "@reduxjs/toolkit"
import log from "~/lib/log"
import type { BasketAction } from "~/store/basket/actions"
import type { CheckoutAction } from "~/store/checkout/actions"
import { CheckoutActions } from "~/store/checkout/constants"
import type { OrderActions } from "~/store/order/actions"
import { OrderActionType } from "~/store/order/constants"
import { QuickCheckoutActionType } from "~/store/quick-checkout/constants"

export const uwaMiddleware: Middleware =
  () =>
  (next) =>
  async (action: CheckoutAction | BasketAction | OrderActions) => {
    switch (action.type) {
      case CheckoutActions.USER_REGISTER_SUCCESS:
      case CheckoutActions.AUTH_SUCCESS:
      case OrderActionType.PAYMENT_SUCCESS:
      case QuickCheckoutActionType.PAYMENT_SUCCESS:
      case CheckoutActions.USER_DATA_SUCCESS:
        if (process.env.GATSBY_STORE_DOMAIN) {
          try {
            let accountId: number | null = null

            if ("accountId" in action && action.accountId) {
              accountId = action.accountId
            }

            if (
              action.type === CheckoutActions.USER_DATA_SUCCESS &&
              action?.result?.user?.id
            ) {
              accountId = action.result.user.id
            }

            if (accountId) {
              setupUWA(process.env.GATSBY_STORE_DOMAIN, accountId).then(() => {
                log(
                  `uwa setup complete for domain ${process.env.GATSBY_STORE_DOMAIN}`,
                  "uwa"
                )
              })
            }
          } catch (error) {
            log(error, "uwa")
          }
        }

        break
    }

    return next(action)
  }
